import { ActionType } from 'typesafe-actions';
import * as activitiesAction from './activities';
import * as filterAction from './filters';

export type ActivitiesActions = ActionType<typeof activitiesAction>;
export const activitiesActions = { ...activitiesAction };

export type FilterActions = ActionType<typeof filterAction>;
export const filterActions = { ...filterAction };
